import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Xverse wallet',
    tooltip: 'Available only for mainnet',
  },
};
